const { createSelector } = require('reselect');
const { pageSelector } = require('selectors/page/pageSelector');
const Empty = require('constants/empty');

const homeSelector = createSelector(pageSelector, page => page.home || Empty.Object);

module.exports = { homeSelector };
